// Chill Garden: collection filter → card image sync
// Externalised from theme.liquid + cg-shield.liquid for performance.
// When the seat-count filter is active, swap card thumbnails to the matching variant image.
(function(){
  function xn(t){var m=t.match(/^(\d+)/);return m?parseInt(m[1],10):0;}
  function sm(f,s){
    var fn=xn(f);if(!fn)return f===s;
    var sn=xn(s);if(!sn)return false;
    if(fn===sn)return true;
    var r=s.match(/^(\d+)-(\d+)/);
    return r&&fn>=parseInt(r[1],10)&&fn<=parseInt(r[2],10);
  }
  function si(cid,url){
    var c=document.getElementById(cid);if(!c)return;
    var img=c.querySelector('.card__media .media img:first-child');if(!img)return;
    img.style.transition='opacity 0.25s';img.style.opacity='0.4';
    var n=new Image();
    n.onload=function(){img.src=url;img.srcset='';img.style.opacity='1';};
    n.onerror=function(){img.style.opacity='1';};
    n.src=url;
    setTimeout(function(){if(img.style.opacity==='0.4'){img.src=url;img.srcset='';img.style.opacity='1';}},400);
  }
  function sync(){
    var p=new URLSearchParams(window.location.search),sf=[];
    p.forEach(function(v,k){if(k==='filter.p.m.custom.seats')sf.push(decodeURIComponent(v));});
    if(!sf.length)return;
    document.querySelectorAll('.card-swatches').forEach(function(c){
      var done=false;
      c.querySelectorAll('.card-swatches__text').forEach(function(b){
        if(done)return;var t=b.textContent.trim();
        for(var i=0;i<sf.length;i++){
          if(sm(sf[i],t)&&!b.classList.contains('card-swatches__text--active')){
            var g=b.closest('.card-swatches__group');
            if(g)g.querySelectorAll('.card-swatches__text--active').forEach(function(e){e.classList.remove('card-swatches__text--active');});
            b.classList.add('card-swatches__text--active');
            if(b.dataset.variantImage)si(b.dataset.cardId,b.dataset.variantImage);
            done=true;return;
          }
        }
      });
      if(!done)c.querySelectorAll('.card-swatches__select').forEach(function(sel){
        if(done)return;
        for(var i=0;i<sel.options.length;i++){
          var ot=sel.options[i].textContent.trim();
          for(var j=0;j<sf.length;j++){
            var fn=xn(sf[j]);
            if(fn&&ot.match(new RegExp('^'+fn+'椅'))){
              if(sel.selectedIndex!==i){sel.selectedIndex=i;var im=sel.options[i].dataset.variantImage;if(im)si(sel.dataset.cardId,im);}
              done=true;return;
            }
          }
        }
      });
    });
  }
  var op=history.pushState;
  history.pushState=function(){op.apply(history,arguments);setTimeout(sync,300);setTimeout(sync,800);setTimeout(sync,1500);};
  window.addEventListener('popstate',function(){setTimeout(sync,300);setTimeout(sync,800);setTimeout(sync,1500);});
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',sync):sync();
})();
